export function isHoliday(date: Date): boolean {
  const day = date.getDate();
  const month = date.getMonth() + 1;

  // Ano Novo
  if (day === 1 && month === 1) {
    return true;
  }

  // Carnaval
  if (day === 3 && month === 3) {
    return true;
  }
  // Carnaval
  if (day === 4 && month === 3) {
    return true;
  }

  // Sexta-Feira Santa
  if (day === 18 && month === 4) {
    return true;
  }

  // Tiradentes
  if (day === 21 && month === 4) {
    return true;
  }

  // Dia do Trabalho
  if (day === 1 && month === 5) {
    return true;
  }

  // Corpus Christi
  if (day === 19 && month === 6) {
    return true;
  }

  // Comemoração da Independência do Brasil
  if (day === 7 && month === 9) {
    return true;
  }

  // Dias das Crianças  | Nossa senhora da Aparecida no Brasil
  if (day === 12 && month === 10) {
    return true;
  }

  // Finados
  if (day === 2 && month === 11) {
    return true;
  }

  // Programação da República
  if (day === 15 && month === 11) {
    return true;
  }

  // Dia da Consciência Negra
  if (day === 20 && month === 11) {
    return true;
  }

  // Véspera Natal do ano de 2022
  if (day === 23 && month === 12) {
    return true;
  }

  // Véspera Natal
  if (day === 24 && month === 12) {
    return true;
  }

  // Natal
  if (day === 25 && month === 12) {
    return true;
  }

  // Véspera Ano novo
  if (day === 30 && month === 12) {
    return true;
  }

  // Véspera Ano novo
  if (day === 31 && month === 12) {
    return true;
  }

  return false;
}

export function addingDayWork(date: Date, noOfDaysToAdd: number): Date {
  const startDate = new Date(date);
  let endDate: Date = startDate;
  if (noOfDaysToAdd === 0) {
    return endDate;
  } else {
    let count = 0;

    while (count < noOfDaysToAdd) {
      endDate = new Date(startDate.setDate(startDate.getDate() + 1));

      if (
        endDate.getDay() !== 0 &&
        endDate.getDay() !== 6 &&
        !isHoliday(endDate)
      ) {
        //Date.getDay() gives weekday starting from 0(Sunday) to 6(Saturday)
        count++;
      }
    }
    return endDate;
  }
}
